import { Helmet } from 'react-helmet-async';
// sections
import { LoginView } from '../../sections/auth';

// ----------------------------------------------------------------------

export default function LoginPage() {
  return (
    <>
      <Helmet>
        <title> CategorizIA </title>
      </Helmet>

      <LoginView />
    </>
  );
}
